<template>
    <section class="slice slice-versus-comparison">
        <div :class="{'slice-content': !isResourcesCenter}">
            <MktVersusComparison
                :title="props.slice.primary.title ?? undefined"
                :subtitle="props.slice.primary.subtitle ?? undefined"
                :left-column-label="props.slice.primary.leftColumnTitle ?? ''"
                :right-column-label="props.slice.primary.rightColumnTitle ?? ''"
                :items="items"
                :cta-label="props.slice.primary.ctaLabel ?? undefined"
                :cta-url="props.slice.primary.ctaLink ?? undefined"
            />
        </div>
    </section>
</template>
<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VersusComparisonSlice} from '@prismicio-types';
    import {MktVersusComparison} from '#components';
    import type {ComparisonItem} from '../../components/versus-comparison/VersusComparisonList.vue';
    import useModuleConfig from '../../composables/useModuleConfig';

    const props = defineProps(getSliceComponentProps<VersusComparisonSlice>(['slice', 'index', 'slices', 'context']));

    const isResourcesCenter = useModuleConfig().theme === 'resources-center';

    const items: ComparisonItem[] = props.slice.primary.leftColumnLines.map((line, index) => ({
        left: line.label?.toString() ?? '',
        leftIsChecked: line.isChecked,
        right: props.slice.primary.rightColumnLines[index]?.label?.toString() ?? '',
        rightIsChecked: props.slice.primary.rightColumnLines[index]?.isChecked ?? false,
    }));
</script>

<style lang="scss">
    .slice-versus-comparison {
        .slice-content {
            max-width: 1024px;
        }
    }
</style>
